import {httpPost} from "../../utils/Request";

export class HousekeepingService {

	async removerPresencasExpiradas() {
		return await httpPost("/housekeeping/remover-presencas-expiradas");
	}

}
